import { HC_LANGUAGES } from '../../../../constants/shared/HomeConnectConstants';

const { ENG, SPA } = HC_LANGUAGES;

/**
 * Get the page config object for render based on language and available measures
 * @param {Array} availableMeasures The list of measures which are available for selected student
 * @param {Boolean} isEnglishChecked Is English language is selected for student
 * @param {Boolean} isSpanishChecked Is Spanish language is selected for student
 * @param {Boolean} letterPages The list of pages which are available for selected student
 * @returns {Array} list of page Config that we are rendering for the student
 */
export const getPagesConfiguration = (
    availableMeasures,
    isEnglishChecked,
    isSpanishChecked,
    letterPages,
) => {
    const listOfLanguages = [ENG, SPA].filter(
        language =>
            (language === ENG && isEnglishChecked) || (language === SPA && isSpanishChecked),
    );
    const pagesConfiguration = letterPages.filter(letterPage =>
        availableMeasures
            .map(measure => measure.key)
            .some(measure => letterPage.summaryMeasures.includes(measure)),
    );
    return [].concat(
        ...listOfLanguages.map(language =>
            pagesConfiguration.map(pageConfig => ({
                language,
                pageConfig,
            })),
        ),
    );
};

export const getMergedStudentsData = (studentsData, selectedStudentsData, letterPages) =>
    selectedStudentsData.map(({ id, isEnglishChecked, isSpanishChecked }) => {
        const studentData = studentsData.find(({ studentInfo }) => studentInfo.id === id);
        return {
            ...studentData,
            listOfPages: getPagesConfiguration(
                studentData.availableMeasures,
                isEnglishChecked,
                isSpanishChecked,
                letterPages,
            ),
        };
    });
